import Support_Overview from '@/components/Support/Support_Overview.vue';
import { FEATURES } from '@/constants/features';
import { sectionRoutes } from './helpers';

// Consolidated Service Desk workspace (items 7+8). One role-adaptive route
// family rendering Support_Overview: staff get the full tabbed workspace
// (Work | Activity | Service Desk); customers with MODULE_SERVICE_DESK get the
// bare Service Desk. `staffBypass` admits Kairon staff even without the tenant
// feature flag.
const SUPPORT_META = {
  canAccess: FEATURES.MODULE_SERVICE_DESK,
  staffBypass: true,
  requiresAuth: true,
  layout: 'default',
};

const selectedIdProps = (route) => ({ selectedId: route.params.selectedId });
const libraryPageProps = (route) => ({
  libraryPath: route.params.libraryPath || null,
  libraryTab: route.params.libraryTab || null,
});
const page = { component: Support_Overview };

export const SUPPORT_ROUTES = [
  { path: '/support', redirect: '/support/service-desk' },
  // Requirements / Tickets / Timeline collapsed into /support/work. Each keeps
  // its :selectedId so existing deep links still land on the item, following
  // the /beta/support/* catch-all precedent in router/index.js.
  //
  // FLAG FOR EVAN: Cerberus's morning #eng report deep-links
  // /beta/support/tickets/<id>, which reaches this table through that catch-all
  // and now resolves via a second hop to /support/work/<id>. It keeps working,
  // but the link should be updated at source.
  { path: '/support/requirements', redirect: '/support/work' },
  { path: '/support/requirements/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  { path: '/support/tickets', redirect: '/support/work' },
  { path: '/support/tickets/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  { path: '/support/timeline', redirect: '/support/work' },
  { path: '/support/timeline/:selectedId', redirect: (to) => `/support/work/${to.params.selectedId}` },
  { path: '/support/tests', redirect: '/support/library/tests' },
  ...sectionRoutes({
    meta: SUPPORT_META,
    tabKey: 'supportTab',
    routes: [
      ['/support/service-desk', 'Support-ServiceDesk', 'service-desk', page],
      ['/support/service-desk/:selectedId', 'Support-ServiceDeskDetail', 'service-desk', { ...page, props: selectedIdProps }],
      ['/support/work', 'Support-Work', 'work', page],
      ['/support/work/:selectedId', 'Support-WorkDetail', 'work', { ...page, props: selectedIdProps }],
      ['/support/activity', 'Support-Activity', 'activity', page],
      // Hades. Staff-only in effect: the tab is not rendered on the customer shell,
      // and ensureCustomerRoute() bounces any non-staff user who reaches the path
      // directly back to the Service Desk. The read API is superuser-gated anyway,
      // so a customer landing here would get an empty portfolio rather than data.
      ['/support/hades', 'Support-Hades', 'hades', page],
      ['/support/library', 'Support-Library', 'library', page],
      // The checker's run log: every nightly and on-demand run, with per-sentence
      // outcomes. A static path, so it outranks the module catch-all below.
      ['/support/library/tests', 'Support-LibraryTests', 'library', { ...page, props: () => ({ libraryView: 'runs' }) }],
      // Module paths are hierarchical, so this parameter deliberately includes
      // slashes (for example, /support/library/features/login_and_account).
      ['/support/library/:libraryPath(.*)', 'Support-LibraryDetail', 'library', { ...page, props: libraryPageProps }],
      ['/support/library/:libraryPath(.*)/:libraryTab(overview|checks|history|code|related)', 'Support-LibraryTab', 'library', { ...page, props: libraryPageProps }],
      ['/support/latency', 'Support-AppLatency', 'latency', { ...page, meta: { requiresSuperUser: true } }],
    ],
  }),
];

export default SUPPORT_ROUTES;
